import { call, put, takeLatest } from 'redux-saga/effects'
import * as api from 'api/postsApi'
import * as actions from 'actions/spamPostActions'
import { IAction } from 'types/redux'
import { refreshAccessToken } from './authSaga'

function* getSpamPosts({ data, token }: IAction) {
  try {
    const response = yield call(api.getSpamPosts, data, token)

    yield put(actions.getSpamPostsSuccess(response.data))
  } catch (e: any) {
    if (e.errors && e.errors[0]?.code === 112) {
      yield call(refreshAccessToken)
      yield put(actions.getSpamPostsRequest(data))
    } else {
      yield put(actions.getSpamPostsError(e.errors))
    }
  }
}

function* updateSpamPostStatus({ data }: IAction) {
  try {
    const response = yield call(api.setPostModerationStatus, data.workspaceId, data.postId, data.status)

    yield put(actions.updateSpamPostStatusSuccess(response.data))
  } catch (e: any) {
    if (e.errors && e.errors[0]?.code === 112) {
      yield call(refreshAccessToken)
      yield put(actions.updateSpamPostStatusRequest(data))
    } else {
      yield put(actions.updateSpamPostStatusError(e.errors))
    }
  }
}

function* spamPostsSaga(): any {
  yield takeLatest(actions.GET_SPAM_POSTS_REQUEST, getSpamPosts)
  yield takeLatest(actions.UPDATE_SPAM_POST_STATUS_REQUEST, updateSpamPostStatus)
}

export default spamPostsSaga
